import { render } from "./BaseTextarea.vue?vue&type=template&id=89f3aefa&scoped=true&ts=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts"

import "./BaseTextarea.vue?vue&type=style&index=0&id=89f3aefa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f3aefa"]])

export default __exports__